import React from 'react';
import './index.scss';

import Paper from '@material-ui/core/Paper';

export default class InformationBox extends React.Component {

    render() {
        return (
            <Paper elevation={1} className={'info-box'}>
                <h6>{this.props.title}</h6>
                <p>{this.props.content}</p>
            </Paper>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/basic/informationBox/index.js